document.addEventListener('DOMContentLoaded', function () {
	const overviews = Array.from(document.querySelectorAll('.Grid.Overview, .News.Overview > .right, .Team.Overview'));
	if (overviews.length) {
		overviews.forEach(overview => {
			function equalizeInnerHeights() {
				const inners = Array.from(overview.querySelectorAll('.Item > .inner, .Item > a > .inner'));

				// Reset heights first
				inners.forEach(inner => {
					inner.style.minHeight = 'initial';
				});

				// Group by row (based on offsetTop)
				const rows = {};
				inners.forEach(inner => {
					const top = inner.getBoundingClientRect().top; // or inner.offsetTop
					if (!rows[top]) {
						rows[top] = [];
					}
					rows[top].push(inner);
				});

				// Equalize each row separately
				Object.values(rows).forEach(rowItems => {
					let maxHeight = 0;
					rowItems.forEach(inner => {
						if (inner.offsetHeight > maxHeight) {
							maxHeight = inner.offsetHeight;
						}
					});
					rowItems.forEach(inner => {
						inner.style.minHeight = maxHeight + 'px';
					});
				});
			}

			// Run on load
			equalizeInnerHeights();

			// Run again on resize
			window.addEventListener('resize', equalizeInnerHeights);

			// Use this if using Ajax filtering -- Search and Filter Pro
			(function ( $ ) {
				"use strict";
				$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
					equalizeInnerHeights();
				});
			}(jQuery));
		});
	}
});
